import { ArrowForwardIos } from '@interhyp/platform-icons';
import React, { Children } from 'react';
import { StepperProgress } from "./components/stepperProgress/StepperProgress.js";
import { Button } from "../button/Button.js";
import styles from "./Stepper.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Stepper({
  activeIndex,
  children,
  onNext,
  onBack
}) {
  const totalSteps = Children.count(children);
  const clampedActiveIndex = Math.min(totalSteps - 1, activeIndex);
  const isNotFirst = clampedActiveIndex > 0;
  const isNotLast = clampedActiveIndex < totalSteps - 1;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.stepper,
    children: [/*#__PURE__*/_jsx(StepperProgress, {
      activeIndex: clampedActiveIndex,
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.controls,
      children: [isNotFirst && onBack && /*#__PURE__*/_jsx(Button, {
        className: styles.back,
        onClick: onBack,
        variant: "text"
        /* TODO: Rework in HP-928 */,
        iconLeft: /*#__PURE__*/_jsx(ArrowForwardIos, {
          className: styles.leftArrow
        }),
        children: "Zur\xFCck"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.current,
        children: [clampedActiveIndex + 1, " von ", totalSteps]
      }), isNotLast && onNext && /*#__PURE__*/_jsx(Button, {
        className: styles.next,
        onClick: onNext,
        variant: "text",
        iconRight: ArrowForwardIos,
        children: "Weiter"
      })]
    })]
  });
}